import { Select } from "@totalenergiescode/mobility-business-rev-design-system";
import {
  Suffix,
  translateChoice,
  translateField,
  useFormDataContext,
} from "@totalenergiescode/mobility-business-rev-form-data/components";
import { type ChangeEvent } from "react";

interface SimpleSelectProps {
  fieldId: string;
}

const SimpleSelect = ({ fieldId }: SimpleSelectProps) => {
  const { findFieldById, translatorFor, dataTestIdPrefix } =
    useFormDataContext();

  const field = findFieldById(fieldId);
  const value = field.value.asChoice();
  const items = Array.from(value.items().entries());
  const writable = field.writable;

  const translator = translatorFor(field);
  const label = translateField(translator, field, Suffix.LABEL);

  const helperText = field.hasHelper()
    ? translateField(translator, field, Suffix.HELP).toString()
    : "";

  const error = field.violations().length > 0;
  const errorMessage = field.violations().at(0)?.translate(translator);

  const onChange = (e: ChangeEvent<HTMLSelectElement>) => {
    field.setValue(e.target.value);
  };

  return (
    <>
      <Select
        type='options'
        options={items.map(([option, _selected]) => ({
          id: option.code(),
          value: option.code(),
          label: translateChoice(
            translator,
            field,
            option,
            Suffix.LABEL,
          ).toString(),
        }))}
        value={value.hasBeenSet() ? value.selection()?.code() : ""}
        onChange={(event) =>
          onChange(event as unknown as ChangeEvent<HTMLSelectElement>)
        }
        disabled={!writable}
        errorMessage={errorMessage || ""}
        error={error}
        label={label.toString()}
        key={field.id()}
        helperText={helperText}
        dataTestId={`${dataTestIdPrefix}-${field.id()}`}
      />
    </>
  );
};

export default SimpleSelect;
